import { useTranslation } from 'react-i18next'

import { FullScreenMessage } from '@/components/feedback/FullScreenMessage'

export function UnsupportedEnvironment() {
  const { t } = useTranslation()

  return (
    <FullScreenMessage
      title={t('telegram.unsupportedTitle')}
      description={t('telegram.unsupportedDescription')}
    />
  )
}
